function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}
module.exports = _isString;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isString.js
// module id = 58
// module chunks = 0